// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");
require("component-leaflet-map");
require("leaflet.markercluster");

var $ = require("./lib/qsa");
var xhr = require("./lib/xhr");

var mapElement = $.one("leaflet-map");
var map = mapElement.map;
var L = mapElement.leaflet;

var strings = {
  "no visible retrofit": "No evidence of retrofit",
  "substantial alteration": "Comprehensive retrofit",
  "permitted retrofit": "Some amount of retrofit",
  "visible retrofit": "Surface evidence of retrofit"
};

var masonry = window.masonryData;

var clusterLayer = new L.MarkerClusterGroup({
  maxClusterRadius: 20,
  showCoverageOnHover: false,
  spiderfyOnMaxZoom: false,
  zoomToBoundsOnClick: true,
  disableClusteringAtZoom: 16,
  iconCreateFunction(cluster) {
    var count = cluster.getChildCount();
    var mix = cluster.getAllChildMarkers().reduce(function(total, marker) {
      return total + (marker.data.level.indexOf("No visible") > -1 ? 0 : 1);
    }, 0) / count;
    var mixClass = mix < .4 ? "unaltered" : 
      mix < .6 ? "mostly-unaltered" : 
      mix < .8 ? "even-mix" : 
      mix < 1 ? "mostly-altered" :
      "retrofitted";
    var clusterClass = count >= 50 ? "large" : count >= 10 ? "medium" : "small";
    var clusterSize = count >= 50 ? 60 : count >= 10 ? 30 : 20;
    return L.divIcon({
      html: cluster.getChildCount(),
      className: `urm-cluster ${clusterClass} ${mixClass}`,
      iconSize: [clusterSize, clusterSize]
    });
  }
});

var clickedMarker = function(e) {
  var marker = e.layer;
  var data = marker.data;
  map.openPopup(`
<h3>${data.address}</h3>
<ul class="data">
  <li> Retrofit level: <b>${strings[data.level.toLowerCase()]}</b>
  <li> Building type: <b>${data.use}</b>
  <li> Occupancy range: <b>${data.occupancy}</b>
  <li> Built: <b>${data.built || "on unknown date"}</b>
</ul>
  `, e.latlng);
};

var clickedCluster = function() {

};

masonry.forEach(function(row) {
  if (!row.lat) return;
  var marker = new L.Marker([row.lat, row.lng], {
    icon: L.divIcon({
      className: "building-marker " + row.level.replace(/\s+/g, "_").toLowerCase()
    })
  });
  marker.data = row;
  marker.addTo(clusterLayer);
});

clusterLayer.on("click", clickedMarker);

clusterLayer.addTo(map);
map.fitBounds([[47.690, -122.412], [47.585, -122.274]]);